import { useTournaments } from '@/api/tournaments';
import StakedCarousel from '@/components/core/StakedCarousel';
import { Image } from '@starsoft/common/components';
import { motion } from 'framer-motion';
import useTranslation from 'next-translate/useTranslation';
import TournamentsCard from '../Content/Cards/Card';
import { fadeInDown, fadeInUp } from './variants';

import { platformAssets } from '@/utils/assets';
import styles from './styles.module.scss';

export default function TournamentsHero(): JSX.Element {
  const { t } = useTranslation('tournaments');

  const { isLoading, error, tournaments, refetch } = useTournaments({
    limit: 9,
    query: '',
    status: null,
  });

  return (
    <div className={styles.container}>
      <motion.div
        className={styles.container__column}
        variants={fadeInUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        <div className={styles.logo}>
          <Image
            src={platformAssets.logo.icon}
            width={50}
            height={50}
            className={styles.logo__image}
            alt="logo"
          />
        </div>
        <h1 className={styles.container__title}>
          {t('tournaments_label')} {platformAssets.app}
        </h1>
        <p className={styles.container__description}>
          {t('tournaments_description', { app_provider: platformAssets.app })}
        </p>
      </motion.div>
      <motion.div
        className={styles.container__column}
        variants={fadeInDown}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        <div className={styles.container__carousel}>
          <StakedCarousel
            data={tournaments ?? null}
            error={error}
            refetch={refetch}
            component={tournament => (
              <TournamentsCard
                key={`tournament-card-${tournament?.id}`}
                position={tournament?.id}
                item={tournament}
                hideGames
                isLoading={isLoading}
              />
            )}
          />
        </div>
      </motion.div>
    </div>
  );
}
